import ActivitiesBoard from "@/components/ActivitiesBoard";
import { useAuth } from "@/context/AuthContext";

export default function ManagerActivities() {
  const { user } = useAuth();
  return (
    <ActivitiesBoard
      actor="responsabile_commerciale"
      title="Attività Responsabile"
      subtitle="Affiancamenti alle agenzie e visite del Responsabile Commerciale."
      readOnly={user?.role === "head_of_partner"}
    />
  );
}
